export { DMS_MODULE } from '../../constants';

export const NAME = 'DoServisuPredal';
export const CRUMB_LABEL_KEY = 'grdDoServisuPredal';
